import { useTranslation } from 'react-i18next';
import { useRef, useEffect, useState } from 'react';

const PAIN_ICONS = ['💸', '🔗', '🌫️', '💔', '😰'];
const PAIN_KEYS = ['saving', 'debt', 'clarity', 'couple', 'month'];
const PAIN_COLORS = ['#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#3b82f6'];

export default function PainPointsSection() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-20 px-4 bg-gray-950 text-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-display font-bold text-center mb-14">
          {t('landing.painPoints.sectionTitle')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {PAIN_KEYS.map((key, i) => (
            <div
              key={key}
              className={`relative rounded-2xl p-6 border border-gray-800 bg-gray-900/60
                         transition-all duration-700 ${
                visible
                  ? 'opacity-100 translate-y-0'
                  : 'opacity-0 translate-y-8'
              }`}
              style={{
                transitionDelay: `${i * 120}ms`,
                borderLeftColor: PAIN_COLORS[i],
                borderLeftWidth: '3px',
              }}
            >
              {/* Watermark number */}
              <div
                className="absolute top-3 right-4 text-6xl font-extrabold opacity-5"
                style={{ color: PAIN_COLORS[i] }}
              >
                {i + 1}
              </div>

              <span className="text-3xl mb-3 block">{PAIN_ICONS[i]}</span>
              <h3 className="text-lg font-bold mb-2 text-white">
                {t(`landing.painPoints.items.${key}.title`)}
              </h3>
              <p className="text-sm text-gray-400 leading-relaxed mb-4">
                {t(`landing.painPoints.items.${key}.description`)}
              </p>

              {/* Stat box */}
              <div
                className="inline-flex items-baseline gap-2 px-3 py-2 rounded-lg"
                style={{ backgroundColor: `${PAIN_COLORS[i]}15` }}
              >
                <span
                  className="text-xl font-extrabold"
                  style={{ color: PAIN_COLORS[i] }}
                >
                  {t(`landing.painPoints.items.${key}.stat`)}
                </span>
                <span className="text-xs text-gray-400">
                  {t(`landing.painPoints.items.${key}.statLabel`)}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
